/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2020, Bulb Inc. For more information, please email contact@hellobulb.com.
 *          _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
*/

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslocoModule } from '@jsverse/transloco';

import { BreadcrumbModule } from 'primeng/breadcrumb';
import { CheckboxModule } from 'primeng/checkbox';
import { ClipboardModule, ClipboardService } from 'ngx-clipboard';
import { FocusTrapModule } from 'primeng/focustrap';
import { ScrollPanelModule } from 'primeng/scrollpanel';

import { AeroModule } from 'src/aero/aero.module';
import { AeroDialogService } from 'src/aero/aero-dialog/aero-dialog.service';
import { AvatarModule } from 'src/app/avatar/avatar.module';
import { BulbCkeditorModule } from 'src/ckeditor/bulb-ckeditor.module';
import { BulbCommonModule } from 'src/common/bulb-common.module';
import { BulbImageModule } from 'src/app/image/bulb-image.module';

import { UppyModule } from 'src/app/uppy/uppy.module';
import { DragDropModule } from 'primeng/dragdrop';
import { MenusModule } from 'src/app/menus/menus.module';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { ResumeAboutMeComponent } from './about-me/about-me.component';
import { ResumeComponent } from './resume.component';
import { ResumeContactDetailsComponent } from './contact-details/contact-details.component';
import { ResumeContactInfoDialogComponent } from './contact-info-dialog/contact-info-dialog.component';
import { ResumeContentSelectionBreadCrumbsComponent }
  from './content-selection-modal/content-selection-breadcrumbs/content-selection-breadcrumbs.component';
import { ResumeContentSelectionDisplayComponent }
  from './content-selection-modal/content-selection-display/content-selection-display.component';
import { ResumeContentSelectionModalComponent } from './content-selection-modal/content-selection-modal.component';
import { ResumeCustomSectionComponent } from './custom-section/custom-section.component';
import { ResumeEducationComponent } from './education/education.component';
import { ResumeExperienceComponent } from './experience/experience.component';
import { ResumeSectionComponent } from './section/section.component';
import { ResumeService } from './resume.service';
import { ResumeSocialProfileDialogComponent } from './social-profile-dialog/social-profile-dialog.component';
import { ResumeSubSectionComponent } from './sub-section/sub-section.component';
import { LogoUploadComponent } from './logo-upload/logo-upload.component';
import { SectionDataAlertService } from './section/section-data-alert.service';

/**
 * Feature Module for our Resume feature.
 */
@NgModule({
  declarations: [
    LogoUploadComponent,
    ResumeAboutMeComponent,
    ResumeComponent,
    ResumeContactInfoDialogComponent,
    ResumeContactDetailsComponent,
    ResumeContentSelectionBreadCrumbsComponent,
    ResumeCustomSectionComponent,
    ResumeContentSelectionDisplayComponent,
    ResumeContentSelectionModalComponent,
    ResumeEducationComponent,
    ResumeExperienceComponent,
    ResumeSectionComponent,
    ResumeSocialProfileDialogComponent,
    ResumeSubSectionComponent,
  ],
  imports: [
    AeroModule,
    AvatarModule,
    BreadcrumbModule,
    BulbCkeditorModule,
    BulbCommonModule,
    BulbImageModule,
    CheckboxModule,
    ClipboardModule,
    CommonModule,
    DragDropModule,
    FocusTrapModule,
    FormsModule,
    MenusModule,
    ScrollPanelModule,
    SvgIconComponent,
    TranslocoModule,
    UppyModule,
  ],
  exports: [
    ResumeContentSelectionDisplayComponent,
  ],
  providers: [
    AeroDialogService,
    ClipboardService,
    ResumeService,
    SectionDataAlertService,
  ],
})
export class ResumeModule { }
